import { EuiButtonProps, EuiFlexGroup, EuiFlexItem, EuiButtonEmpty } from "@elastic/eui";
import { Subjects } from "settings/permissions";
import { isSubjectAuthorizedForUser } from "utils";
import { FC } from "react";
import { createUseStyles } from "react-jss";
import Button from "../Buttons/Button";

interface FdFormButtonsProps {
  authRoles?: "Read" | "Write" | "Admin";
  authSubject?: Subjects;
  isRightButtonDisabled?: boolean;
  leftButtonProps?: EuiButtonProps;
  leftButtonText?: string;
  middleButtonProps?: EuiButtonProps;
  middleButtonText?: string;
  onLeftButtonClick?: (e: any) => any;
  onMiddleButtonClick?: (e: any) => any;
  onRightButtonClick?: (e: any) => any;
  rightButtonProps?: EuiButtonProps;
  rightButtonText?: string;
  showLeftButton?: boolean;
  showMiddleButton?: boolean;
  showRightButton?: boolean;
  isRightButtonLoading?: boolean;
}

const useStyles = createUseStyles({
  fdFormButtons: {},
  save: {
    boxShadow: "0px 2px 2px rgba(152, 162, 179, 0.15)",
    borderRadius: 6,
  },
});

const FdFormButtons: FC<FdFormButtonsProps> = ({
  authSubject,
  authRoles,
  onRightButtonClick = () => {},
  onMiddleButtonClick = () => {},
  rightButtonText = "Save",
  middleButtonText = "Cancel",
  leftButtonText = "Back",
  isRightButtonDisabled = false,
  middleButtonProps = {},
  rightButtonProps = {},
  leftButtonProps = {},
  onLeftButtonClick = () => {},
  showLeftButton = false,
  showMiddleButton = true,
  showRightButton = true,
  isRightButtonLoading = false,
}) => {
  const classes = useStyles();

  if (authSubject) {
    const isAllowed = isSubjectAuthorizedForUser({
      subject: authSubject,
      //@ts-ignore
      role: authRoles,
    });

    if (!isAllowed) return null;
  }

  return (
    <div className={classes.fdFormButtons} data-testid="fdFormButtons">
      <EuiFlexGroup gutterSize="s" justifyContent="flexEnd" responsive={false}>
        {showLeftButton && (
          <>
            <EuiFlexItem grow={false}>
              <Button type="back" text={leftButtonText} onClick={onLeftButtonClick} />
            </EuiFlexItem>
            <EuiFlexItem />
          </>
        )}

        {showMiddleButton && (
          <EuiFlexItem grow={false}>
            <Button type="secondary" text={middleButtonText} onClick={onMiddleButtonClick} />
          </EuiFlexItem>
        )}

        {showRightButton && (
          <EuiFlexItem grow={false}>
            <Button
              type="primary"
              text={rightButtonText}
              onClick={onRightButtonClick}
              isLoading={isRightButtonLoading}
              disabled={isRightButtonDisabled}
            />
          </EuiFlexItem>
        )}
      </EuiFlexGroup>
    </div>
  );
};

export default FdFormButtons;
